import styles from "@/styles/modules/components/viewAll.module.scss";
import Link from "next/link";

interface ViewAllProps {
  text: string;
  link: string;
}

export default function ViewAll({ text, link }: ViewAllProps) {
  return (
    <section className={styles.viewAll}>
      <div className={styles.viewAllContainer}>
        <Link href={link}>{text}</Link>
      </div>
    </section>
  );
}
